import * as React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { changeNavigationStack } from '../../actions/navigation'

import '../../sass/answers/chatbutton.scss'
import { RootState } from '../../types/rootstate'

interface StateProps {
  hub: RootState['hub']
}

interface DispatchProps {
  navigateToOnline: () => void
}

interface OwnProps {
  text: string
}

type ChatButtonProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    hub: state.hub
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    navigateToOnline: () =>
      dispatch(changeNavigationStack('online'))
  }
}

interface ChatButtonState {}

class ChatButtonComponent extends React.Component<ChatButtonProps, ChatButtonState> {
  handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.navigateToOnline()
  }

  handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.navigateToOnline()
    }
  }

  render () {
    const onlineHubItem = this.props.hub && this.props.hub.find((hubItem) => hubItem.type === 'online')

    if (onlineHubItem) {
      return (
        <div className='col-xs-12'>
          <div
            className='chatbutton accentSecondaryButton'
            onClick={this.handleClick}
            tabIndex={0}
            role='button'
            onKeyDown={this.handleKeyDown}
            >
            <img src={onlineHubItem.agentPicture} alt='' />
            <span>{this.props.text}</span>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

const ChatButton = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(ChatButtonComponent)

export {
  ChatButton
}
